import script from "./AdminEditVacancy.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminEditVacancy.vue?vue&type=script&setup=true&lang=js"

import "./AdminEditVacancy.vue?vue&type=style&index=0&id=434c227a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-434c227a"]])

export default __exports__